// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"85":"39cf4101","486":"8f892994","541":"944b77c0","633":"9f2d01cd","700":"f7ab121c","961":"8f57625f"}[chunkId] + ".js";
};